// extracted by css-extract-rspack-plugin
export default {"cls1":"abandoned_cart_ping-cls1_an8","cls2":"abandoned_cart_ping-cls2_fx3 abandoned_cart_ping-cls1_an8"};